


















import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component
export default class InputFormOrder extends Vue {
  @Inject()
  $validator: Validator

  order: string | null = null

  get validationString(): object {
    const hex = '[0-9a-fA-F]'
    const regexForShortId = `${hex}{8}(-${hex}{4}){3}-${hex}{12}`
    const regexForCompressedId = '[0-9a-zA-Z]+'
    const regexForOldMacaron = '[0-9a-zA-Z]{10}-?[0-9]{5}'
    const regex = `^(${regexForShortId}|${regexForCompressedId}|${regexForOldMacaron})$`

    return {
      required: this.isRequired,
      regex,
    }
  }

  @Prop({ required: true })
  isRequired: boolean

  @Prop({ required: true })
  input: (value: string, field: string) => void
}
